var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6162 14.1727C12.6162 14.1727 19.2899 15.8305 25.1559 9.83691C25.1559 9.83691 30.0018 15.656 37.9082 14.383C37.9082 14.383 38.6308 34.5338 25.2622 38.1469C25.2622 38.1469 12.6096 36.064 12.6162 14.1727Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2652 25.1334C26.5955 25.1334 27.674 24.055 27.674 22.7247C27.674 21.3944 26.5955 20.3159 25.2652 20.3159C23.9349 20.3159 22.8564 21.3944 22.8564 22.7247C22.8564 24.055 23.9349 25.1334 25.2652 25.1334Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2656 29.745V25.1338",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0738 10.5758C43.4041 10.5758 44.4826 9.49738 44.4826 8.16706C44.4826 6.83674 43.4041 5.7583 42.0738 5.7583C40.7435 5.7583 39.665 6.83674 39.665 8.16706C39.665 9.49738 40.7435 10.5758 42.0738 10.5758Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94 27.5426C48.2703 27.5426 49.3488 26.4642 49.3488 25.1339C49.3488 23.8035 48.2703 22.7251 46.94 22.7251C45.6097 22.7251 44.5312 23.8035 44.5312 25.1339C44.5312 26.4642 45.6097 27.5426 46.94 27.5426Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0738 44.2418C43.4041 44.2418 44.4826 43.1634 44.4826 41.8331C44.4826 40.5028 43.4041 39.4243 42.0738 39.4243C40.7435 39.4243 39.665 40.5028 39.665 41.8331C39.665 43.1634 40.7435 44.2418 42.0738 44.2418Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.915 18.5085H42.074V10.7725",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5361 25.1338H44.5317",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0215 31.1997H42.074V39.4227",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02399 10.5758C9.35432 10.5758 10.4328 9.49738 10.4328 8.16706C10.4328 6.83674 9.35432 5.7583 8.02399 5.7583C6.69367 5.7583 5.61523 6.83674 5.61523 8.16706C5.61523 9.49738 6.69367 10.5758 8.02399 10.5758Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15681 27.5426C4.48713 27.5426 5.56557 26.4642 5.56557 25.1339C5.56557 23.8035 4.48713 22.7251 3.15681 22.7251C1.82649 22.7251 0.748047 23.8035 0.748047 25.1339C0.748047 26.4642 1.82649 27.5426 3.15681 27.5426Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02399 44.2418C9.35432 44.2418 10.4328 43.1634 10.4328 41.8331C10.4328 40.5028 9.35432 39.4243 8.02399 39.4243C6.69367 39.4243 5.61523 40.5028 5.61523 41.8331C5.61523 43.1634 6.69367 44.2418 8.02399 44.2418Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1824 18.5085H8.02344V10.7725",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.562 25.1338H5.56641",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0759 31.1997H8.02344V39.4227",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg12);
export default __webpack_public_path__ + "static/media/Website icons SVG-12.ee9d43345b064cdd27f2f3f315231cb3.svg";
export { ForwardRef as ReactComponent };